import { render, staticRenderFns } from "./DataRadio.vue?vue&type=template&id=0e45c8bd&"
import script from "./DataRadio.vue?vue&type=script&lang=js&"
export * from "./DataRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e45c8bd')) {
      api.createRecord('0e45c8bd', component.options)
    } else {
      api.reload('0e45c8bd', component.options)
    }
    module.hot.accept("./DataRadio.vue?vue&type=template&id=0e45c8bd&", function () {
      api.rerender('0e45c8bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DataRadio.vue"
export default component.exports